import { AloSecurityItem } from '@/models/alo/AloSecurityItem'

export enum SecurityItemsKeys {
  HIDDEN = 'HIDDEN',
  HOME_PILOT = 'HOME_PILOT',
  HOME_MAINTENANCE = 'HOME_MAINTENANCE',
  HOME_ADMINISTRATION = 'HOME_ADMINISTRATION',
  HOME_VIEW_DATA = 'HOME_VIEW_DATA',
  HOME_MISSION_PLANNING = 'HOME_MISSION_PLANNING',
  HOME_SMART_PLANNING = 'HOME_SMART_PLANNING',
  PILOT_REACH_DETAIL = 'PILOT_REACH_DETAIL',
  PILOT_DETAIL_MAP = 'PILOT_DETAIL_MAP',
  PILOT_DETAIL_INFORMATION_PANEL = 'PILOT_DETAIL_INFORMATION_PANEL',
  PILOT_DETAIL_CUSTOM_SCIENCE_PLOT = 'PILOT_DETAIL_CUSTOM_SCIENCE_PLOT',
  PILOT_DETAIL_MAIN_SCIENCE_PLOTS = 'PILOT_DETAIL_MAIN_SCIENCE_PLOTS',
  PILOT_DETAIL_CUSTOM_NAVIGATION_PLOT = 'PILOT_DETAIL_CUSTOM_NAVIGATION_PLOT',
  PILOT_DETAIL_MAIN_NAVIGATION_PLOTS = 'PILOT_DETAIL_MAIN_NAVIGATION_PLOTS',
  PILOT_DETAIL_CUSTOM_NMEA_PLOT = 'PILOT_DETAIL_CUSTOM_NMEA_PLOT',
  PILOT_DETAIL_MAIN_NMEA_PLOTS = 'PILOT_DETAIL_MAIN_NMEA_PLOTS',
  PILOT_DETAIL_AD2CP = 'PILOT_DETAIL_AD2CP',
  PILOT_DETAIL_IMAGE = 'PILOT_DETAIL_IMAGE',
  PILOT_DETAIL_COMMAND_CONSOLE = 'PILOT_DETAIL_COMMAND_CONSOLE',
  PILOT_DETAIL_COMMAND_CONSOLE_MOD_CONF_FILTER = 'PILOT_DETAIL_COMMAND_CONSOLE_MOD_CONF_FILTER',
  PILOT_DETAIL_NEXT_SURFACING_DO = 'PILOT_DETAIL_NEXT_SURFACING_DO',
  PILOT_DETAIL_SEND_MAIL = 'PILOT_DETAIL_SEND_MAIL',
  PILOT_DETAIL_MAP_LAYER = 'PILOT_DETAIL_MAP_LAYER',
  PILOT_DETAIL_FILE_TRANSFERT = 'PILOT_DETAIL_FILE_TRANSFERT',
  PILOT_DETAIL_FILE_TRANSFERT_CONFIG = 'PILOT_DETAIL_FILE_TRANSFERT_CONFIG',
  PILOT_DETAIL_FILE_UPLOAD = 'PILOT_DETAIL_FILE_UPLOAD',
  PILOT_DETAIL_SINGLE_WAY_POINT = 'PILOT_DETAIL_SINGLE_WAY_POINT',
  PILOT_DETAIL_FTP_RSYNC = 'PILOT_DETAIL_FTP_RSYNC',
  PILOT_DETAIL_CORIOLIS = 'PILOT_DETAIL_CORIOLIS',
  PILOT_DETAIL_MISSION_PLANNING = 'PILOT_DETAIL_MISSION_PLANNING',
  PILOT_DETAIL_LOGBOOK = 'PILOT_DETAIL_LOGBOOK',
  PILOT_DETAIL_FLEET_MANAGEMENT = 'PILOT_DETAIL_FLEET_MANAGEMENT',
  PILOT_DETAIL_ANTICOLLISION = 'PILOT_DETAIL_ANTICOLLISION',
  PILOT_DETAIL_QUICK_CONTROL = 'PILOT_DETAIL_QUICK_CONTROL',
  PILOT_DETAIL_ENCRYPTION = 'PILOT_DETAIL_ENCRYPTION',
  DEBUG_LOG = 'DEBUG_LOG',
  ADMIN_GLIDER = 'ADMIN_GLIDER',
  ADMIN_COMPANY = 'ADMIN_COMPANY',
  ADMIN_MOBIL_UNIT_CLASS = 'ADMIN_MOBIL_UNIT_CLASS',
  ADMIN_MOBIL_UNIT_TYPE = 'ADMIN_MOBIL_UNIT_TYPE',
  ADMIN_MOBIL_UNIT = 'ADMIN_MOBIL_UNIT',
  ADMIN_USER = 'ADMIN_USER',
  ADMIN_ROLE = 'ADMIN_ROLE',
  ADMIN_MESURETYPE = 'ADMIN_MESURETYPE',
  ADMIN_MESUREUNIT = 'ADMIN_MESUREUNIT',
  ADMIN_MISSION = 'ADMIN_MISSION',
  ADMIN_FLEET = 'ADMIN_FLEET',
  ADMIN_POSITIONREMARQUABLE = 'ADMIN_POSITIONREMARQUABLE',
  ADMIN_MAP_LAYER = 'ADMIN_MAP_LAYER',
  ADMIN_UPLOAD_MISSION = 'ADMIN_UPLOAD_MISSION',
  ADMIN_COMMAND_COMPLETION = 'ADMIN_COMMAND_COMPLETION',
  ADMIN_MESSAGE_LOGIN = 'ADMIN_MESSAGE_LOGIN',
  ADMIN_NMEA_DISPLAY = 'ADMIN_NMEA_DISPLAY',
  ADMIN_HOME_IMAGE = 'ADMIN_HOME_IMAGE',
  ADMIN_PWD_POLICY = 'ADMIN_PWD_POLICY',
}

export enum SecurityRoles {
  sysadmin = 'sysadmin',
  admin = 'admin',
  pilot = 'pilot',
  scientist = 'scientist',
  debug = 'debug',
  tester = 'tester',
  scienceobserver = 'science-observer',
  adcp = 'adcp',
  logbook = 'logbook',
  manager = 'manager',
  operator = 'operator',
  encryption = 'encryption',
}

export const getDefaultSecurityRights = (): { [index: string]: AloSecurityItem } => {
  return {
    [SecurityItemsKeys.HOME_PILOT]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.HOME_MAINTENANCE]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.HOME_ADMINISTRATION]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.HOME_VIEW_DATA]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.HOME_MISSION_PLANNING]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.HOME_SMART_PLANNING]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.PILOT_REACH_DETAIL]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.PILOT_DETAIL_MAP]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.PILOT_DETAIL_INFORMATION_PANEL]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.PILOT_DETAIL_CUSTOM_SCIENCE_PLOT]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.PILOT_DETAIL_MAIN_SCIENCE_PLOTS]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.PILOT_DETAIL_CUSTOM_NAVIGATION_PLOT]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.PILOT_DETAIL_MAIN_NAVIGATION_PLOTS]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.PILOT_DETAIL_CUSTOM_NMEA_PLOT]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.PILOT_DETAIL_MAIN_NMEA_PLOTS]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.PILOT_DETAIL_AD2CP]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.PILOT_DETAIL_IMAGE]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.PILOT_DETAIL_COMMAND_CONSOLE]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.PILOT_DETAIL_COMMAND_CONSOLE_MOD_CONF_FILTER]: new AloSecurityItem({
      enable: false,
      visible: false,
    }),
    [SecurityItemsKeys.PILOT_DETAIL_NEXT_SURFACING_DO]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.PILOT_DETAIL_SEND_MAIL]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.PILOT_DETAIL_MAP_LAYER]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.PILOT_DETAIL_FILE_TRANSFERT]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.PILOT_DETAIL_FILE_TRANSFERT_CONFIG]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.PILOT_DETAIL_FILE_UPLOAD]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.PILOT_DETAIL_SINGLE_WAY_POINT]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.PILOT_DETAIL_FTP_RSYNC]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.PILOT_DETAIL_CORIOLIS]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.PILOT_DETAIL_MISSION_PLANNING]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.PILOT_DETAIL_LOGBOOK]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.PILOT_DETAIL_FLEET_MANAGEMENT]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.PILOT_DETAIL_ANTICOLLISION]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.PILOT_DETAIL_QUICK_CONTROL]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.PILOT_DETAIL_ENCRYPTION]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.DEBUG_LOG]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.ADMIN_GLIDER]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.ADMIN_COMPANY]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.ADMIN_MOBIL_UNIT_CLASS]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.ADMIN_MOBIL_UNIT_TYPE]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.ADMIN_MOBIL_UNIT]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.ADMIN_USER]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.ADMIN_ROLE]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.ADMIN_MESURETYPE]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.ADMIN_MESUREUNIT]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.ADMIN_MISSION]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.ADMIN_FLEET]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.ADMIN_POSITIONREMARQUABLE]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.ADMIN_MAP_LAYER]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.ADMIN_UPLOAD_MISSION]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.ADMIN_COMMAND_COMPLETION]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.ADMIN_MESSAGE_LOGIN]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.ADMIN_NMEA_DISPLAY]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.ADMIN_HOME_IMAGE]: new AloSecurityItem({ enable: false, visible: false }),
    [SecurityItemsKeys.ADMIN_PWD_POLICY]: new AloSecurityItem({ enable: false, visible: false }),
  }
}

export const calculSecurityRights = (roles: Array<string>) => {
  let secus = {} as { [index: string]: AloSecurityItem }
  if (roles) {
    secus = roles
      .map(r => SecurityRightsByRoles[r])
      .filter(r => r)
      .reduce((concatRights, currentRights) => {
        Object.keys(concatRights).forEach(key => {
          concatRights[key].enable = concatRights[key].enable || currentRights[key]?.enable
          concatRights[key].visible = concatRights[key].visible || currentRights[key]?.visible
        })
        return concatRights
      }, getDefaultSecurityRights())
  } else {
    secus = getDefaultSecurityRights()
  }
  return secus
}

export const SecurityRightsByRoles: { [index: string]: { [index: string]: AloSecurityItem } } = {
  [SecurityRoles.sysadmin]: {
    [SecurityItemsKeys.HOME_PILOT]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.HOME_MAINTENANCE]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.HOME_VIEW_DATA]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.HOME_MISSION_PLANNING]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.HOME_SMART_PLANNING]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_REACH_DETAIL]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_MAP]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_INFORMATION_PANEL]: new AloSecurityItem({ enable: false, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_CUSTOM_SCIENCE_PLOT]: new AloSecurityItem({ enable: false, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_MAIN_SCIENCE_PLOTS]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_CUSTOM_NAVIGATION_PLOT]: new AloSecurityItem({ enable: false, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_MAIN_NAVIGATION_PLOTS]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_MAIN_NMEA_PLOTS]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_AD2CP]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_IMAGE]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_COMMAND_CONSOLE]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_COMMAND_CONSOLE_MOD_CONF_FILTER]: new AloSecurityItem({
      enable: true,
      visible: true,
    }),
    [SecurityItemsKeys.PILOT_DETAIL_NEXT_SURFACING_DO]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_SEND_MAIL]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_MAP_LAYER]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_FILE_TRANSFERT]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_FILE_TRANSFERT_CONFIG]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_FILE_UPLOAD]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_SINGLE_WAY_POINT]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_FTP_RSYNC]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_CORIOLIS]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_MISSION_PLANNING]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_LOGBOOK]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_FLEET_MANAGEMENT]: new AloSecurityItem({ enable: false, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_ANTICOLLISION]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_QUICK_CONTROL]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_ENCRYPTION]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_GLIDER]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_COMPANY]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_MOBIL_UNIT_CLASS]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_MOBIL_UNIT_TYPE]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_MOBIL_UNIT]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_USER]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_ROLE]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_MESURETYPE]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_MESUREUNIT]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_MISSION]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_FLEET]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_POSITIONREMARQUABLE]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_MAP_LAYER]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_UPLOAD_MISSION]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_COMMAND_COMPLETION]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_MESSAGE_LOGIN]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_NMEA_DISPLAY]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_HOME_IMAGE]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_PWD_POLICY]: new AloSecurityItem({ enable: true, visible: true }),
  },
  [SecurityRoles.admin]: {
    [SecurityItemsKeys.HOME_PILOT]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.HOME_MAINTENANCE]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.HOME_VIEW_DATA]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.HOME_MISSION_PLANNING]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.HOME_SMART_PLANNING]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_REACH_DETAIL]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_MAP]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_INFORMATION_PANEL]: new AloSecurityItem({ enable: false, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_MAIN_SCIENCE_PLOTS]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_MAIN_NAVIGATION_PLOTS]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_MAIN_NMEA_PLOTS]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_IMAGE]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_COMMAND_CONSOLE]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_NEXT_SURFACING_DO]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_SEND_MAIL]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_MAP_LAYER]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_FILE_TRANSFERT]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_FILE_TRANSFERT_CONFIG]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_FILE_UPLOAD]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_SINGLE_WAY_POINT]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_FTP_RSYNC]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_CORIOLIS]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_LOGBOOK]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_ANTICOLLISION]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_QUICK_CONTROL]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_GLIDER]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_COMPANY]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_MOBIL_UNIT_CLASS]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_MOBIL_UNIT_TYPE]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_MOBIL_UNIT]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_USER]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_ROLE]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_MESURETYPE]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_MESUREUNIT]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_MISSION]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_FLEET]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_POSITIONREMARQUABLE]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_MAP_LAYER]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_UPLOAD_MISSION]: new AloSecurityItem({ enable: true, visible: true }),
    // RG-ADM-032 : message de connexion, images d'accueil, config NMEA et complétion de commandes
    // sont des paramètres globaux, réservés au sysadmin.
  },
  [SecurityRoles.manager]: {
    [SecurityItemsKeys.HOME_MAINTENANCE]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_GLIDER]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_COMPANY]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_USER]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_MISSION]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_FLEET]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_POSITIONREMARQUABLE]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_UPLOAD_MISSION]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.ADMIN_MAP_LAYER]: new AloSecurityItem({ enable: true, visible: true }),
  },
  [SecurityRoles.pilot]: {
    [SecurityItemsKeys.HOME_PILOT]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.HOME_MAINTENANCE]: new AloSecurityItem({ enable: false, visible: true }),
    [SecurityItemsKeys.HOME_VIEW_DATA]: new AloSecurityItem({ enable: false, visible: true }),
    [SecurityItemsKeys.HOME_MISSION_PLANNING]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.HOME_SMART_PLANNING]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_REACH_DETAIL]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_MAP]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_INFORMATION_PANEL]: new AloSecurityItem({ enable: false, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_MAIN_SCIENCE_PLOTS]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_MAIN_NAVIGATION_PLOTS]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_MAIN_NMEA_PLOTS]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_IMAGE]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_COMMAND_CONSOLE]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_NEXT_SURFACING_DO]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_SEND_MAIL]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_MAP_LAYER]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_FILE_TRANSFERT]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_FILE_TRANSFERT_CONFIG]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_FILE_UPLOAD]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_SINGLE_WAY_POINT]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_FTP_RSYNC]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_CORIOLIS]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_MISSION_PLANNING]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_LOGBOOK]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_ANTICOLLISION]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_QUICK_CONTROL]: new AloSecurityItem({ enable: true, visible: true }),
  },
  [SecurityRoles.operator]: {
    [SecurityItemsKeys.HOME_PILOT]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.HOME_MAINTENANCE]: new AloSecurityItem({ enable: false, visible: true }),
    [SecurityItemsKeys.HOME_VIEW_DATA]: new AloSecurityItem({ enable: false, visible: true }),
    [SecurityItemsKeys.HOME_MISSION_PLANNING]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.HOME_SMART_PLANNING]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_REACH_DETAIL]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_MAP]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_INFORMATION_PANEL]: new AloSecurityItem({ enable: false, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_MAIN_SCIENCE_PLOTS]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_MAIN_NAVIGATION_PLOTS]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_MAIN_NMEA_PLOTS]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_IMAGE]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_COMMAND_CONSOLE]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_NEXT_SURFACING_DO]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_SEND_MAIL]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_MAP_LAYER]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_FILE_TRANSFERT]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_FILE_TRANSFERT_CONFIG]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_FILE_UPLOAD]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_SINGLE_WAY_POINT]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_FTP_RSYNC]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_CORIOLIS]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_MISSION_PLANNING]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_LOGBOOK]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_ANTICOLLISION]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_QUICK_CONTROL]: new AloSecurityItem({ enable: true, visible: true }),
  },
  [SecurityRoles.scientist]: {
    [SecurityItemsKeys.HOME_PILOT]: new AloSecurityItem({ enable: false, visible: true }),
    [SecurityItemsKeys.HOME_MAINTENANCE]: new AloSecurityItem({ enable: false, visible: true }),
    [SecurityItemsKeys.HOME_VIEW_DATA]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.HOME_MISSION_PLANNING]: new AloSecurityItem({ enable: false, visible: true }),
    [SecurityItemsKeys.HOME_SMART_PLANNING]: new AloSecurityItem({ enable: false, visible: true }),
    [SecurityItemsKeys.PILOT_REACH_DETAIL]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_MAP]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_INFORMATION_PANEL]: new AloSecurityItem({ enable: false, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_MAIN_SCIENCE_PLOTS]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_MAIN_NAVIGATION_PLOTS]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_MAIN_NMEA_PLOTS]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_IMAGE]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_FILE_TRANSFERT]: new AloSecurityItem({ enable: true, visible: true }),
  },
  [SecurityRoles.debug]: {
    [SecurityItemsKeys.DEBUG_LOG]: new AloSecurityItem({ enable: true, visible: true }),
  },
  [SecurityRoles.tester]: {},
  [SecurityRoles.scienceobserver]: {
    [SecurityItemsKeys.HOME_PILOT]: new AloSecurityItem({ enable: false, visible: true }),
    [SecurityItemsKeys.HOME_MAINTENANCE]: new AloSecurityItem({ enable: false, visible: true }),
    [SecurityItemsKeys.HOME_VIEW_DATA]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.HOME_MISSION_PLANNING]: new AloSecurityItem({ enable: false, visible: true }),
    [SecurityItemsKeys.HOME_SMART_PLANNING]: new AloSecurityItem({ enable: false, visible: true }),
    [SecurityItemsKeys.PILOT_REACH_DETAIL]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_MAP]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_INFORMATION_PANEL]: new AloSecurityItem({ enable: false, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_MAIN_SCIENCE_PLOTS]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_MAIN_NAVIGATION_PLOTS]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_MAIN_NMEA_PLOTS]: new AloSecurityItem({ enable: true, visible: true }),
    [SecurityItemsKeys.PILOT_DETAIL_IMAGE]: new AloSecurityItem({ enable: true, visible: true }),
  },
  [SecurityRoles.adcp]: {
    [SecurityItemsKeys.PILOT_DETAIL_AD2CP]: new AloSecurityItem({ enable: true, visible: true }),
  },
  [SecurityRoles.logbook]: {
    [SecurityItemsKeys.PILOT_DETAIL_LOGBOOK]: new AloSecurityItem({ enable: true, visible: true }),
  },
  [SecurityRoles.encryption]: {
    [SecurityItemsKeys.PILOT_DETAIL_ENCRYPTION]: new AloSecurityItem({ enable: true, visible: true }),
  },
}
